/**
 *
 */

export const API_URL_WINTER = process.env.API_URL_WINTER || '/api/resort/v01/winter/overview';
export const API_URL_TRANSPORTATION = process.env.API_URL_TRANSPORTATION || '/api/transportation/v01/status';
export const API_URL_TEXTS = process.env.API_URL_TEXTS || '/api/resort/v01/texts';
export const API_URL_WEATHER = process.env.API_URL_WEATHER || '/api/weather/v01/detail';
export const API_URL_POIS = `${process.env.ROUTE_PREFIX}data/pois.json`;

export const API_URL_OVERPASS = '//overpass.osm.ch/api/interpreter';
